<template>
  <div :class="$style.container" ref="editor" class="editor">
  </div>
</template>
<script>
import E from 'wangeditor'
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      editor: ''
    }
  },
  watch: {
    text (newValue) {
      this.editor.txt.html(newValue)
    }
  },
  mounted () {
    this.editor = new E(this.$refs.editor)
    this.editor.customConfig.uploadImgShowBase64 = true
    this.editor.customConfig.uploadImgServer = '/wapi/v1/uploads'
    this.editor.customConfig.uploadImgHooks = {
      before: function (xhr, editor, files) {

      },
      success: function (xhr, editor, result) {

      },
      fail: function (xhr, editor, result) {

      },
      error: function (xhr, editor) {

      },
      timeout: function (xhr, editor) {

      },
      customInsert: function (insertImg, result, editor) {
        let url = result.data.url
        insertImg(url)
      }
    }
    this.editor.customConfig.onchange = (html) => {
      // html 即变化之后的内容
      this.$emit('html', html)
    }
    this.editor.create()
  }
}
</script>
<style lang="scss" module>
</style>
<style scoped>
  .editor >>> .w-e-menu {
    padding: 5px 5px;
  }
  .editor >>> .w-e-text-container {
    height: 200px!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/echo/components/etitor.vue